module.exports = __webpack_public_path__ + "img/conveniq-logo.7e1724ba.png";